import React from 'react';

interface PublicationLegendProps {
    BulletMainAuthor: string;
    BulletMajorAuthor: string;
}

const PublicationLegend: React.FC<PublicationLegendProps> = ({
    BulletMainAuthor,
    BulletMajorAuthor,
}) => {
    return (
        <div className='mx-auto px-4'>
            <p className='text-textGrey font-condensed text-center font-extralight text-md flex justify-center items-center flex-wrap gap-x-2'>
                <span className='relative inline-flex items-center pl-5'>
                    <span className='mr-4'>Main Author(s)</span>
                    <span className="before:content-[''] before:absolute before:right-0 before:top-1.5 before:w-3 before:h-3 before:bg-textRedLight before:rounded-none"></span>
                </span>
                <span className='relative inline-flex items-center'>
                    <span className='mr-4'>, Major Contributor Author(s)</span>
                    <span className="before:content-[''] before:absolute before:right-0 before:top-1.5 before:w-3 before:h-3 before:bg-textGrey before:rounded-full"></span>
                </span>
            </p>
        </div>
    );
};

export default PublicationLegend;